import React, { useMemo, useState, useCallback } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import useI18n from 'hooks/useI18n'
import { Button, Flex, Text, useModal } from '@pancakeswap-libs/uikit'
import { useBurn, useAnnuitySwitchToPayout, useAnnuitySwitchToStaking, useStakeToAnnuity, useAnnuityForcePayout, useAnnuityCollectPayout } from '../hooks/useSep20Factory'
import StakeModal from './StakeModal'
import BurnMoal from './BurnMoal'
import ForcePayoutModal from './ForcePayoutModal'

const Action = styled.div`
    padding-top: 5px;
`

interface CardActionsProps {
    token: any,
    account?: string
}

const CardActions: React.FC<CardActionsProps> = ({ token, account }) => {
    const TranslateString = useI18n();
    const { address, status, accountBalance, currentEstimate } = token;

    // Switch Mode
    const [requestedSwitchMode, setRequestedSwitchMode] = useState(false)
    const onSwitchToPayout = useAnnuitySwitchToPayout(address);
    const handleSwitchToPayout = useCallback(async () => {
        try {
            setRequestedSwitchMode(true)
            await onSwitchToPayout()
            setRequestedSwitchMode(false)
        } catch (e) {
            console.error(e)
        }
    }, [onSwitchToPayout])
    const onSwitchToStaking = useAnnuitySwitchToStaking(address);
    const handleSwitchToStaking = useCallback(async () => {
        try {
            setRequestedSwitchMode(true)
            await onSwitchToStaking()
            setRequestedSwitchMode(false)
        } catch (e) {
            console.error(e)
        }
    }, [onSwitchToStaking])
    const renderSwitchButton = () => {
        if (accountBalance && accountBalance.isGreaterThan(0)) {
            return (
                <Button mt="8px" fullWidth onClick={status > 0 ? handleSwitchToPayout : handleSwitchToStaking} disabled={requestedSwitchMode}>
                    {/* Switch to { status > 0 ? "Payout": "Staking" } Mode */}
                    {status > 0?
                        TranslateString(1056, `Switch to Payout Mode`):
                        TranslateString(1054, `Switch to Staking Mode`)
                    }
                </Button>
            )
        }
        return "";
    }

    // Collect Payout
    const [requestedCollectPayout, setRequestedCollectPayout] = useState(false)
    const onCollectPayout = useAnnuityCollectPayout(address);
    const handleCollectPayout = useCallback(async () => {
        try {
            setRequestedCollectPayout(true)
            await onCollectPayout()
            setRequestedCollectPayout(false)
        } catch (e) {
            console.error(e)
        }
    }, [onCollectPayout])
    const renderCollectPayoutButton = () => {
        if (status === 0 && accountBalance && accountBalance.isGreaterThan(0)) {
            return (
                <Button mt="8px" fullWidth onClick={handleCollectPayout} disabled={requestedCollectPayout}>
                    {TranslateString(1052, 'Collect Available Payout')}
                </Button>
            )
        }
        return "";
    }

    // Stake
    const tokenBalance = token.userBalance? token.userBalance.toFixed() : '0';
    const onStakeSubmit = useStakeToAnnuity(address)
    const onStakeModalConfirm = async (amount) => {
        return onStakeSubmit(new BigNumber(amount));
    };
    const [onStakeStart] = useModal(<StakeModal max={tokenBalance} token={token} onConfirm={onStakeModalConfirm} />)
    const renderStakeButton = () => {
        if (status > 0 || accountBalance && !accountBalance.isGreaterThan(0)) {
            return (
                <Button mt="8px" fullWidth onClick={onStakeStart}>
                    {TranslateString(94, 'Stake')}
                </Button>
            )
        }
        return "";
    }

    // Force Payout
    const pendingPayout = token.accountBalance? token.accountBalance.toFixed() : '0';
    const onForcePayoutSubmit = useAnnuityForcePayout(address)
    const onForcePayoutModalConfirm = async (amount) => {
        return onForcePayoutSubmit(new BigNumber(amount));
    };
    const [onForcePayoutStart] = useModal(<ForcePayoutModal max={pendingPayout} token={token} onConfirm={onForcePayoutModalConfirm} />)
    const renderForcePayoutButton = () => {
        if (status === 0 && accountBalance && accountBalance.isGreaterThan(0)) {
            return (
                <Button mt="8px" fullWidth onClick={onForcePayoutStart}>
                    {TranslateString(1053, 'Force Payout')}
                </Button>
            )
        }
        return "";
    }

    // Burn
    const onBurnSubmit = useBurn(token)
    const onBurnModalConfirm = async (amount) => {
        return onBurnSubmit(new BigNumber(amount));
    };
    const [onBurnStart] = useModal(<BurnMoal max={tokenBalance} token={token} onConfirm={onBurnModalConfirm} />)

    return (
        <Action>
            <Button fullWidth onClick={onBurnStart}>
                {TranslateString(546,'Burn')}
            </Button>
            {renderCollectPayoutButton()}
            {renderForcePayoutButton()}
            {renderStakeButton()}
            {renderSwitchButton()}
        </Action>
    );
}

export default CardActions
